import { render, staticRenderFns } from "./EditArticlePage.vue?vue&type=template&id=1a69e87a&"
import script from "./EditArticlePage.vue?vue&type=script&lang=js&"
export * from "./EditArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports